import DetailsComponent from './details.vue'

export default DetailsComponent
export { DetailsComponent }
